import { Newspaper, ExternalLink } from "lucide-react";
import { cn } from "@/lib/utils";

const dot = (s) => (s === "Bullish" ? "#00FFA3" : s === "Bearish" ? "#FF3366" : "#A1A1AA");
const tr = { Bullish: "Yükseliş", Bearish: "Düşüş", Neutral: "Nötr" };

export const NewsFeed = ({ news }) => {
  return (
    <div data-testid="news-feed" className="rounded-lg border border-[var(--border)] bg-[var(--app-bg)]">
      <div className="flex items-center gap-2 px-5 h-14 border-b border-[var(--border)]">
        <Newspaper className="h-4 w-4 text-[var(--accent)]" />
        <h3 className="font-head font-bold text-base">Haber Akışı & Duygu Analizi</h3>
      </div>
      <div className="max-h-[520px] overflow-y-auto divide-y divide-[var(--surface-hover)]">
        {news.length === 0 && (
          <div className="text-center py-12 text-[var(--text-faint)]">
            <Newspaper className="h-8 w-8 mx-auto mb-3 opacity-40" />
            <p className="text-sm">Haber yok. Analizi çalıştırın.</p>
          </div>
        )}
        {news.map((n, i) => (
          <a
            key={i}
            href={n.url || "#"}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`news-item-${i}`}
            className="block px-5 py-3.5 hover:bg-[var(--surface-hover)] transition-colors group"
          >
            <div className="flex items-start gap-3">
              <span className="mt-1.5 h-2 w-2 rounded-full flex-shrink-0" style={{ background: dot(n.sentiment) }} />
              <div className="flex-1 min-w-0">
                <p className="text-[13px] leading-snug text-[var(--text-primary)] group-hover:text-[var(--pos)] transition-colors line-clamp-2">
                  {n.title_tr || n.title}
                </p>
                <div className="flex items-center gap-2 mt-1.5 flex-wrap">
                  <span className="text-[10px] text-[var(--text-faint)] uppercase tracking-wider">{n.source}</span>
                  <span
                    className="text-[10px] px-1.5 py-0.5 rounded font-mono uppercase"
                    style={{ background: `${dot(n.sentiment)}1A`, color: dot(n.sentiment) }}
                  >
                    {tr[n.sentiment] || n.sentiment}
                  </span>
                  {(n.assets || []).map((a) => (
                    <span key={a} className="text-[10px] text-[var(--accent)] font-mono">${a}</span>
                  ))}
                  <ExternalLink className="h-3 w-3 text-[var(--text-faint)] ml-auto opacity-0 group-hover:opacity-100 transition-opacity" />
                </div>
              </div>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
};
